export default __webpack_public_path__ + "022253492ca2ba6d110a60a06313af7b.png";